'use strict';
import has from 'lodash/has';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {getCollection, getDomainLink, getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable, observeNewOnScope} from '../../core-utilities/rx-utils';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import template from './person-item-directive.html';


const ANIMATION_DURATION = 1000;
const ONE_MINUTE = 60 * 1000;
const ONE_HOUR_AGO = 60 * ONE_MINUTE;

PersonDirective.$inject = [];

/**
 * Supports attributes:
 *
 * @constructor
 */
export function PersonDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      person: '=ngModel'
    },
    controllerAs: 'personItem',
    bindToController: true,
    controller: [
      '$scope',
      '$element',
      '$attrs',
      '$filter',
      'PersonDomain',
      'userPresenceService',
      PersonController]
  }
}

function PersonController(
  $scope,
  $element,
  $attrs,
  $filter,
  PersonDomain,
  userPresenceService,
) {
  const vm = this;
  const abbreviate = $filter('abbreviate');
  vm.isPerson = isPerson;

  vm.presenceClass = '';

  observeNewOnScope($scope, () => vm.person && vm.person.role)
    .distinctUntilChanged()
    .subscribe(newRole => updateRoleClass(newRole && isString(newRole)));

  observeNewOnScope($scope, () => getId(vm.person))
    .distinctUntilChanged()
    .switchMap(() =>
      vm.person && vm.person.hasOwnProperty('aliasFor') && getLink(vm.person, 'aliasFor').id
        ? Observable.merge(
        watchPresence().map(presenceClass => ({presenceClass: presenceClass})),
        getDomainLink(vm.person, 'aliasFor').then(() => ({delegate: vm.person.getDelegatePerson()})),
      ) : Observable.of({delegate: vm.person})
    ).subscribe(data =>
    $scope.$evalAsync(() => {
      if (has(data, 'presenceClass'))
        vm.presenceClass = data.presenceClass;
      if (has(data, 'delegate'))
        vm.delegate = data.delegate;
    }));

  function isPerson(person) {
    if (!person) {
      return true;
    }
    return person && getCollection(person) === PersonDomain.COLLECTION;
  }

  function updateRoleClass(hasRole) {
    if (hasRole && $attrs.roleClass) {
      $element.addClass($attrs.roleClass);
    } else if (!hasRole && $attrs.roleClass) {
      $element.removeClass($attrs.roleClass);
    }
  }

  function watchPresence() {
    const lastOnline$ = observeNewOnScope($scope, () => vm.person && vm.person.lastOnline ? vm.person.lastOnline.getTime() : null);
    const lastSeen$ = observeNewOnScope($scope, () => vm.person && vm.person.lastSeen ? vm.person.lastSeen.getTime() : null);
    const interval$ = Observable.interval(0, ONE_MINUTE);

    return Observable.combineLatest(
      lastOnline$,
      lastSeen$,
      interval$,
    )
      .switchMap(([lastOnline, lastSeen]) => {
        const now = new Date().getTime() - userPresenceService.INTERVAL;
        const lastObserved = Math.max(lastOnline, lastSeen);
        const updateInterval = now - lastObserved < ONE_HOUR_AGO ? 60 * 1000 : ONE_HOUR_AGO;
        return Observable.merge(
          getPresenceClass(lastOnline, lastSeen),
          Observable.interval(updateInterval, updateInterval)
            .mergeMap(() => getPresenceClass(lastOnline, lastSeen)),
        );
      })
      .distinctUntilChanged()
      .takeUntil(eventToObservable($scope, SCOPE_DESTROY));
  }

  function getPresenceClass(lastOnline, lastSeen) {
    const now = new Date().getTime() - userPresenceService.INTERVAL;
    if (!isNumber(lastOnline) || !isNumber(lastSeen)) {
      return Observable.of('online-icon');
    } else if (now < lastOnline) {
      return Observable.merge(
        Observable.of('online-icon online-icon-available online-icon-pulse'),
        Observable.timer(ANIMATION_DURATION).take(1).mapTo('online-icon online-icon-available')
      );
    } else if (now < lastSeen) {
      return Observable.of('online-icon online-icon-away');
    } else {
      return Observable.empty();
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/directives/PersonDirective.js